// extracted by mini-css-extract-plugin
export var statItem = "_k3-1";
export var statsRow = "_k3-0";